import React, { useEffect, useState } from "react";
import axios from "../../plugins/axios";
import { styled } from "@mui/styles";
import { spacing } from "@mui/system";
import KnowledgeArticlesTable from "./KnowledgeArticlesTable";
import { grey } from "@mui/material/colors";

import {
    Typography,
    Card as MuiCard,
    CardContent,
    Button as MuiIconButton,
    Box,
    Dialog,
    DialogContent,
    CircularProgress
} from "@mui/material";
import {
    Add as AddIcon
} from "@mui/icons-material";

const IconButton = styled(MuiIconButton)({
    padding: '2px',
    marginTop: '-2px',
    marginLeft: '2px',
    minWidth: 0,
    color: grey[700],
});

const Card = styled(MuiCard)(spacing);

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const LinkedArticlesCard = ({ article, setArticle }) => {    

    const [openDialog, setOpenDialog] = useState(false); 

    const [saving, setSaving] = useState(false);

    const addArticle = async id => {
        setOpenDialog(false);
        setSaving(true);
        let newArticle = { ...article, childArticleIds: [...article.childArticleIds, id] };
        await axios.post(`${apiUrl}/knowledge/updatearticle`, { id: article.id, childArticleIds: newArticle.childArticleIds });
        setArticle(newArticle); 
        setSaving(false);
    };

    const removeLink = async id => {
        setSaving(true);
        let newArticle = { ...article, childArticleIds: article.childArticleIds.filter(x => x !== id) };
        await axios.post(`${apiUrl}/knowledge/updatearticle`, { id: article.id, childArticleIds: newArticle.childArticleIds });
        setArticle(newArticle);
        setSaving(false);
    }

    useEffect(() => {
        setSaving(false);
    }, [article.childArticleIds, setSaving]);

    return (
        (<Card mb={6}>
            <CardContent>                
                <Box display="flex">
                    <Box flexGrow={1} alignItems="center">
                        <Typography variant="h6" gutterBottom>Linked Articles</Typography>
                    </Box>
                    <Box>
                        {
                            saving
                            ? <CircularProgress
                                size={21}
                                style={{ marginLeft: "9px" }}
                            />
                                : <IconButton onClick={() => setOpenDialog(true)} size="large">
                                <AddIcon />
                            </IconButton>
                        }
                    </Box>
                </Box>                
                <KnowledgeArticlesTable articleIds={article.childArticleIds} onDelete={removeLink} />
                <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogContent>
                        <KnowledgeArticlesTable
                            onRowClick={id => addArticle(id)}
                            withoutArticleIds={[...article.childArticleIds, article.Id]}
                        />
                    </DialogContent>
                </Dialog>
            </CardContent>
        </Card>)
    );
};

export default LinkedArticlesCard
